import React from "react";
import { default as MUIListItem } from "@mui/material/ListItem";
import styled from "styled-components";

const StyledMUIListItem = styled(MUIListItem)``;

export const ListItem = ({ component }) => {
  return <StyledMUIListItem component={component} />;
};
